import ConnectionStatus from "components/ConnectionStatus";
import { useGameContext } from "GameContext";
import { useWebSocket } from "WebSocketContext";
import { useNavigate } from "react-router-dom"

import React, { useEffect, useState } from "react";
import BackButton from "components/BackButton";
import BasicButton from "components/General/BasicButton";

import PlayersMenu from "components/Player/PlayersMenu";

const WaitingRoom: React.FC = () => {
  const { playerId, socket } = useWebSocket();
  const {
    gameId,
    gameStarted,
    connectedIds,
    currentStage,
  } = useGameContext() as any;

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const message = "Are you sure you want to leave? Data may be lost";
      if (!window.confirm(message)) {
        // User pressed "Cancel" → block unload
        event.preventDefault();
        event.returnValue = "";
      }
      // If user pressed "OK", allow unload
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const navigate = useNavigate()

  function onMessage(event: MessageEvent<string>) {
    if (event.data) {
      const message = JSON.parse(event.data);

      if (message.kind === "StartingGame") {
        navigate("/play/main");
      }
    }
  }

  useEffect(() => {
    if (!socket) return;
    socket.addEventListener("message", onMessage);

    return () => {
      if (socket) {
        socket.removeEventListener("message", onMessage);
      }
    }
  }, [socket]);

  useEffect(() => {
    if (!gameId) {
      navigate("/play/join");
    }
  }, [gameId])


  useEffect(() => {
    if (gameStarted) {
      // JOINING mid game?
      if (currentStage === "vote") {
        navigate("/play/main/vote");
      } else {
        navigate("/play/main");
      }
    }
  }, [
    connectedIds,
    gameStarted,
    currentStage,
    navigate,
  ])

  return (
    <div className="flex h-[100vh] w-full">
      <div className="relative w-full h-full flex flex-col">
        <PlayersMenu />
      </div>

      <ConnectionStatus />
    </div>
  )
}

export default WaitingRoom;
